import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center gap-1.5 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1.5">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs w-4 h-4 flex items-center justify-center"></i>
              )}
              {isLast ? (
                <span className="text-foreground-600" aria-current="page">
                  {item.label}
                </span>
              ) : item.href ? (
                <Link to={item.href} className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-400">{item.label}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}